import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap, pluck } from 'rxjs/operators';
import { DateUtilities } from '@approot/utilities';
import { environment } from 'src/environments/environment';
import { AlertsService } from '../alerts/alerts.service';
import { CloudwatchLogService } from '../cloudwatch-logs/cloudwatch-logs.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class HistoricalService {
  constructor(
    private http: HttpClient,
    private alertsService: AlertsService,
    private cwLog: CloudwatchLogService,
    private authService: AuthService
  ) {}

  getHistorical(tradeType: string, currencyPair: string): Promise<any> {
    return this.authService.currentSession().then(cognito => {
      return this.http
        .post(
          'https://' +
            environment.api_domain +
            '.fxexotics.com/exotics/historical/' +
            currencyPair,
          {
            tradeType: tradeType,
            startDate: DateUtilities.getDateInISOFormat(
              new Date().setDate(new Date().getDate() - 14)
            ),
            endDate: DateUtilities.getDateInISOFormat()
          },
          this.getHeaders(cognito.getIdToken().getJwtToken())
        )
        .pipe(
          tap(() => console.log('retrieved historical data')),
          catchError(this.handleError('historical data error'))
        );
    });
  }

  // optionally pass in the date (single date YYYY-MM-DD or range YYYY-MM-DD-YYYY-MM-DD)
  getHistoricalFixingsForCross(currencyPair: string, date?: string) {
    let d = date ? '/' + date : '';
    return this.authService
      .currentSession()
      .then(amazonCognito => {
        return this.http
          .get(
            'https://' +
              environment.api_domain +
              '.fxexotics.com/exotics/historical/SpotMid/' +
              currencyPair +
              d,
            this.getHeaders(amazonCognito.getIdToken().getJwtToken())
          )
          .pipe(pluck('Items'));
        // pluck operator allows to specify the name of property
        // you wish to extract from the input's stream value.
      })
      .catch(error => {
        this.handleError(error);
      });
  }

  private getHeaders(token) {
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', token);
    return { headers };
  }

  private handleError<T>(operation = 'operation') {
    return (error: HttpErrorResponse): Observable<T> => {
      const message =
        error.error instanceof ErrorEvent
          ? error.error.message
          : `server returned code ${error.status} with body "${error.error}"`;

      // Bonkers, but happens sometimes
      const e = error?.error?.error || error?.error;

      this.alertsService.addAlert({
        message: e
      });
      this.cwLog.logError(error);
      throw new Error(`${operation} failed: ${message}`);
    };
  }
}
